export const schema = [
  {
    id: "/Types/Form",
    type: "object",
    required: [],
    properties: {
      label: { type: "string", default: "" },
      description: { type: "string", default: "" },
      readOnly: { type: "boolean", default: false },
    },
  },
];
